<template>
  <b-modal v-model="visible" title="Edycja konta kursanta" @ok="onOk" @show="onShow">
    <div class="container">
      <b-row>
        <b-form class="col-md-12" @submit.prevent="onSubmit">
          <b-form-group class="required" label="Nr telefonu">
            <b-form-input
              v-model="phoneNumber"
              type="text"
              autocomplete="off"
              :state="$v.phoneNumber.$error? false : null"
              @input="$v.phoneNumber.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.phoneNumber.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Skype">
            <b-form-input
              v-model="skype"
              type="text"
              autocomplete="off"
              :state="$v.skype.$error? false : null"
              @input="$v.skype.$reset()"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.skype.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Domyślna cena za makrocykl [PLN]">
            <b-form-input
              v-model="monthlyPrice"
              type="text"
              autocomplete="off"
              :state="$v.monthlyPrice.$error? false : null"
              @input="$v.monthlyPrice.$reset()"
              @keypress="e => onlyForCurrency(e, this.monthlyPrice)"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.monthlyPrice.isCorrectDecimal">Wpisana wartość jest niepoprawna</div>
              <div v-if="!$v.monthlyPrice.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

           <b-form-group class="required" label="Domyślna cena za makrocykl z samymi rozmowami [PLN]">
            <b-form-input
              v-model="talksOnlyMonthlyPrice"
              type="text"
              autocomplete="off"
              :state="$v.talksOnlyMonthlyPrice.$error? false : null"
              @input="$v.talksOnlyMonthlyPrice.$reset()"
              @keypress="e => onlyForCurrency(e, this.talksOnlyMonthlyPrice)"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.talksOnlyMonthlyPrice.isCorrectDecimal">Wpisana wartość jest niepoprawna</div>
              <div v-if="!$v.talksOnlyMonthlyPrice.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Cena za lekcję">
            <b-form-input
              v-model="lessonPrice"
              type="text"
              autocomplete="off"
              :state="$v.lessonPrice.$error? false : null"
              @input="$v.lessonPrice.$reset()"
              @keypress="e => onlyForCurrency(e, this.lessonPrice)"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.lessonPrice.isCorrectDecimal">Wpisana wartość jest niepoprawna</div>
              <div v-if="!$v.lessonPrice.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group class="required" label="Cena za rozmowę">
            <b-form-input
              v-model="talkPrice"
              type="text"
              autocomplete="off"
              :state="$v.talkPrice.$error? false : null"
              @input="$v.talkPrice.$reset()"
              @keypress="e => onlyForCurrency(e, this.talkPrice)"
            />
            <b-form-invalid-feedback>
              <div v-if="!$v.talkPrice.isCorrectDecimal">Wpisana wartość jest niepoprawna</div>
              <div v-if="!$v.talkPrice.required">To pole jest wymagane</div>
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Opis">
            <b-form-textarea v-model="description" rows="3" max-rows="6" autocomplete="off" />
          </b-form-group>
        </b-form>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";

function replaceCommasWithDots(value) {
  let valueString = value + "";
  return valueString.split(",").join(".");
}

const isCorrectDecimal = value => {
  let valueString = replaceCommasWithDots(value);

  if (
    value == null ||
    (valueString.indexOf(".") > -1 && valueString.split(".")[1].length > 2)
  ) {
    return false;
  } else if (valueString < 0) {
    return false;
  }

  return true;
};

export default {
  data() {
    return {
      visible: false,
      id: null,
      phoneNumber: null,
      skype: null,
      description: null,
      monthlyPrice: null,
      talksOnlyMonthlyPrice: null,
      talkPrice: null,
      lessonPrice: null
    };
  },
  props: ["student"],
  validations: {
    phoneNumber: { required },
    skype: { required },
    monthlyPrice: { required, isCorrectDecimal },
    talksOnlyMonthlyPrice: { required, isCorrectDecimal },
    talkPrice: { required, isCorrectDecimal },
    lessonPrice: { required, isCorrectDecimal }
  },
  methods: {
    show() {
      this.visible = true;
    },
    onShow() {
      this.$v.$reset();

      if (this.student) {
        this.id = this.student.id;
        this.phoneNumber = this.student.phoneNumber;
        this.skype = this.student.skype;
        this.description = this.student.description;
        this.monthlyPrice = this.$options.filters.replaceDotsWithCommas(
          parseFloat(this.student.monthlyPrice).toFixed(2)
        );
         this.talksOnlyMonthlyPrice = this.$options.filters.replaceDotsWithCommas(
          parseFloat(this.student.talksOnlyMonthlyPrice).toFixed(2)
        );
        this.talkPrice = this.$options.filters.replaceDotsWithCommas(
          parseFloat(this.student.talkPrice).toFixed(2)
        );
        this.lessonPrice = this.$options.filters.replaceDotsWithCommas(
          parseFloat(this.student.lessonPrice).toFixed(2)
        );
      } else {
        this.id = null;
        this.phoneNumber = null;
        this.skype = null;
        this.description = null;
        this.monthlyPrice = null;
        this.talksOnlyMonthlyPrice = null;
        this.talkPrice = null;
        this.lessonPrice = null;
      }
    },
    onSubmit() {
      this.$v.$touch();

      if (!this.$v.$error) {
        let result = {
          phoneNumber: this.phoneNumber,
          skype: this.skype,
          description: this.description,
          monthlyPrice: replaceCommasWithDots(this.monthlyPrice),
          talksOnlyMonthlyPrice: replaceCommasWithDots(this.talksOnlyMonthlyPrice),
          talkPrice: replaceCommasWithDots(this.talkPrice),
          lessonPrice: replaceCommasWithDots(this.lessonPrice)
        };

        this.$emit("save", result);
        this.visible = false;
      }
    },
    onOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onlyForCurrency($event, value) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      let valueString = replaceCommasWithDots(value + "");

      // only allow number and one comma
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 44 || valueString.indexOf(".") != -1)
      ) {
        // 46 is dot, 44 is comma
        $event.preventDefault();
      }

      if (
        $event.target.selectionStart > valueString.indexOf(".") &&
        valueString.indexOf(".") != -1
      ) {
        if (
          value != null &&
          valueString.indexOf(".") > -1 &&
          valueString.split(".")[1].length > 1
        ) {
          $event.preventDefault();
        }
      }

      if ($event.target.selectionStart == 0 && $event.key == 0) {
        $event.preventDefault();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

